<div #checkMark [ngClass]="getDivClass()" >
    <div [ngClass]="getCheckMarkClass()"
         #checkButton
         tabindex="{{this.small? -1:0}}"
         [title]="'check-activity.checkMark.title' | translate"
         (click)="onToggleStatusDone($event)">
        <div class="check"></div>
    </div>
</div>
